
    <mat-dialog-content>
        <h3 style="color: #FFF;">{{labels.lblCorrectAnswer}}</h3>
        <div style="margin: auto; text-align: center">
            <button class="button" [class]="buttons" mat-button (click)="onNoClick()" type="button"
                style="margin-top:15px;" matDialogClose>{{labels.lblContinue}}</button>
        </div>

    </mat-dialog-content>
